import React, { useEffect, useState } from 'react';
import { db, auth } from '../firebase/config.js';
import { doc, getDoc, getDocs, addDoc, collection, updateDoc, arrayRemove, setDoc, onSnapshot, deleteDoc, arrayUnion } from "firebase/firestore";
import { useNavigate } from 'react-router-dom';
import { readRetakeSubmissions } from '../control/RetakeSubmissionData.js';

import SignupAppointmentUI from './SignupAppointmentUI.js';

const SignupAppointmentSite = () => {
    const [courses, setCourses] = useState([]);
    const [selectedCourse, setSelectedCourse] = useState(null);
    const [appointmentFullMsg, setAppointmentFullMsg] = useState(false)
    const [myAppointment, setMyAppointment] = useState([])
    const [date, setDate] = useState("")
    const [time, setTime] = useState("")

 


    useEffect(() => {
        console.log("appointment full is: ", appointmentFullMsg)
        console.log("My appointments", myAppointment)
        console.log("Selected Course", selectedCourse)
        // console.log("My appointments", myAppointment)
        console.log("Selected course", selectedCourse)
        fetchAppointments()

    }, [appointmentFullMsg, selectedCourse]);







    async function fetchAppointments() {
        try {

            const user = auth.currentUser;
            if (user) {
                const userDocRef = doc(db, "users", user.uid);
                const userSnapshot = await getDoc(userDocRef)

                onSnapshot(userDocRef, docSnapshot => {
                    if (docSnapshot.exists()) {
                        setAppointmentFullMsg(prev => {
                            return docSnapshot.data().enableRetake; // Ensures re-render
                        });
                    }

                })


                if (userSnapshot.exists()) {
                    const classesRef = collection(db, "classes")
                    const getClasses = await getDocs(classesRef)
                    const classArray = getClasses.docs.map(classes => ({
                        ...classes.data(),
                        id: classes.id
                    }))
                    const studentCourses = classArray.filter(course => userSnapshot.data().enrolledCourses.includes(course.id))

                    setCourses(studentCourses)

                }

            }
        } catch (err) {
            console.log(err)
        }

    }
    const handleSubmit = async () => {

        const user = auth.currentUser
        const userDocRef = doc(db, "users", user.uid);
        await setDoc(userDocRef, { enableRetake: false }, { merge: true })

        // fetchAppointments()
        if (selectedCourse) {
            try {
                const submissions = await readRetakeSubmissions()

                const mySub = submissions.filter(doc => doc.email === user.email)
                console.log("What is my sub?", mySub)
                setMyAppointment(mySub)
                    const submissionRef = collection(db, "retakeSubmissions")
                    const userDocRef = doc(db, "users", user.uid);
                    const userSnapshot = await getDoc(userDocRef)
                    const name = `${userSnapshot.data().firstName} ${userSnapshot.data().lastName}`
                    if(!date || !time){
                        alert("Please select your availability")
                    } else{
                        await addDoc(submissionRef, { studentName: name, department: selectedCourse.name, subject: selectedCourse.subject, instructor: selectedCourse.instructorName, studentEmail: auth.currentUser.email, studentID: user.uid, courseNum: selectedCourse.abbreviatedName, date: date, time: time })
                        setCourses(courses.filter(course => course.id !== selectedCourse.id));
                        setSelectedCourse(null); // Clear the selection after deletion
                        await updateDoc(userDocRef, {
                            enrolledCourses: arrayRemove(selectedCourse.id)
                        });
                        // alert("appointment made successfully")
                        console.log("Selected course", selectedCourse)
                        updateDoc(userDocRef, { appointmentID: arrayUnion(selectedCourse.id) })
                        setDate("")
                        setTime("")
                    }
                   
                    // dateUpdate()



                

            } catch (error) {
                console.error("Error canceling appointment: ", error);
            }
        } else {
            alert('Please select a class to make an appointment');
        }
    };

    return (
        <>
            {appointmentFullMsg &&
                <div style={{ backgroundColor: "gray" }} class="alert alert-danger" role="alert">
                    Appointment full try again later
                </div>}
            <SignupAppointmentUI
                courses={courses}
                selectedCourse={selectedCourse}
                setSelectedCourse={setSelectedCourse}
                handleSubmit={handleSubmit}
                disable={appointmentFullMsg}
                setDate={setDate}
                date={date}
                time = {time}
                setTime={setTime}
            />
        </>

    );
};

export default SignupAppointmentSite;
